import css from 'styles/nav.module.css'
import { logo } from 'assets'
import { formatAddress } from 'utils'
import { Loading, Account } from 'types'

type Props = {
  message: string
  account: Account
  isLoading: Loading
  connectWalletHandler: () => Promise<void>
  changeNetworkHandler: () => Promise<void>
}

export default function Nav({
  message,
  account,
  isLoading,
  connectWalletHandler,
  changeNetworkHandler,
}: Props) {
  return (
    <div className={`${css.container} pd`}>
      <div>
        <img className={css.logo} src={logo} width={46} alt="logo" />
      </div>
      <div className={css.account}>
        {account.balance && (
          <div className={`${css.balance} pseudo_button`}>
            {Number(account.balance).toFixed(3)}
          </div>
        )}
        <DisplayButton
          message={message}
          account={account}
          isLoading={isLoading}
          connectWalletHandler={connectWalletHandler}
          changeNetworkHandler={changeNetworkHandler}
        />
      </div>
    </div>
  )
}

function DisplayButton({
  message,
  account,
  isLoading,
  connectWalletHandler,
  changeNetworkHandler,
}: Props) {
  if (isLoading.nav) {
    return (
      <button
        disabled={true}
        className={`${css.connect} loader`}
        data-emoji="🍌"
      ></button>
    )
  }
  if (message) {
    if (message === 'Wrong Network') {
      return (
        <button onClick={changeNetworkHandler} className="error">
          Wrong Network
        </button>
      )
    }
    return (
      <button disabled={true} className="error">
        Please Install MetaMask
      </button>
    )
  } else if (account.address) {
    return <button disabled={true}>{formatAddress(account.address)}</button>
  }
  return (
    <button onClick={connectWalletHandler} className={css.connect}>
      Connect Wallet
    </button>
  )
}
